import { useDispatch, useSelector } from 'react-redux';
import Afereclassification from './Afereclassification';
import { formatPrice, getFileName, popupInitialData } from "utils";
import TransferAction from 'Store/Component/Transfer/TransferAction';
import { useEffect, useRef, useState } from 'react';
import { getCostCenterBySearchString } from 'Store/Organization/CostCenters/CostCentersAction';
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { v1 as uuid } from "uuid";
import { CONSTANTS } from 'client/utils/constants';
import ConfirmationBee from 'client/assets/images/ConfirmationBee.svg';
import SuccessBee from 'client/assets/images/SuccessBee.svg';
import rejectedBee from 'client/assets/images/ConfirmationBee.svg';
import { buildingImprovementsRequiredFields, fleetEquipmentRequiredFields, furnitureFixturesRequiredFields, LeaseImprovementsRequiredFields } from 'client/utils/AssetUtil';
import { useNavigate, useParams } from 'react-router-dom';
import selectors from "redux/Navigation/selectors";
import navOperations from "redux/Navigation/operations";
import { ApiToReact, ReactToAPI } from 'Service/AFEReClassification/ObjectStructure';
import { getOnlyNumbers } from 'client/utils/RequisitionUtil';
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch';
import pendingOrderOperations from 'redux/PendingOrder/operations';
import { setDeleteCartOrder } from 'Store/OrderManagement/Order/OrderAction';
import Moment from 'moment';
import { getAddressDropDownList } from 'Store/Organization/AutoCompleteAddressSearch/AddressSearchAction';
import { getAddressDetails } from 'Store/Organization/AutoCompleteAddressDetails/AddressDetailsAction';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';

const AfereclassificationContainer = (props?: any) => {
  const { selectedAfeType, setClickedAdd } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [error, setError] = useState<string>("");
  const [list, setList] = useState<any>([]);
  const [attachmentsList, setAttachmentsList] = useState<any>([]);
  const questionError = useRef<any>('');
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const [cancelPopContent, setCancelPopContent] = useState<any>(popupInitialData);
  const [headerNavItem, setHeaderNavItem] = useState("home");
  const [isCancelRequestClicked, setIsCancelRequestClicked] = useState(false)
  const [addressSearchText, setAddressSearchText] = useState<any>();
  const [addressListLoad, setAddressListLoad] = useState<any>();
  const [addressDropDownListTemp, setAddressDropDownListTemp] = useState<any>();
  const [currentClickType, setCurrentClickType] = useState<string>('');

  const { id } = useParams();
  const {
    afeReClassificationData,
    afeBranchSplitData,
    leadrOrderValidation,
    afeAssetDetailData,
    afeBranchAddressDetail,
    docList,
    headerNav,
    afeAssetValidation,
    saveAfeReclassification,
    afeOrderByIdData,
    isEditOrder,
    getUserDetails,
    isOrderCanceled,
    cartOrderDelete,
    addressDropDownList,
    addressDetails
  }: any = useSelector((state: any) => ({
    afeReClassificationData: state.TransferReducer.afeReClassificationData,
    afeBranchSplitData: state.TransferReducer.afeBranchSplitData,
    leadrOrderValidation: state.TransferReducer.leadrOrderValidation,
    afeAssetDetailData: state.TransferReducer.afeAssetDetailData,
    afeBranchAddressDetail: state.TransferReducer.afeBranchAddressDetail,
    docList: state.UploadAttachmentsReducer.list,
    headerNav: selectors.GetHeaderNav(state),
    afeAssetValidation: state.TransferReducer.afeAssetValidation,
    saveAfeReclassification: state.TransferReducer.saveAfeReclassification,
    afeOrderByIdData: state.TransferReducer.afeOrderByIdData,
    isEditOrder: state.TransferReducer.isEditOrder,
    getUserDetails: state.UserProfile.getUserDetails,
    isOrderCanceled: state.PendingOrder.isOrderCanceled,
    cartOrderDelete: state.OrderReducer.cartOrderDelete,
    addressDropDownList: state.AddressDropDownReducer.addressDropDownList,
    addressDetails: state.AddressDetailReducer.addressDetails
  }));

  const dispatchUploadAttachments = UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch);
  const dispatchRemoveAttachment = UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);
  const dispatchGetDeleteCartOrderById = OrderDispatch.dispatchGetDeleteCartOrder(dispatch);
  const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
  const dispatchSetIsOrderCanceled = pendingOrderOperations.dispatchSetIsOrderCanceled(dispatch);

  const clearValues = () => {
    dispatch(TransferAction.setAfeAssetDetailData({}));
    dispatch(TransferAction.setAfeBranchAddressDetail({}));
    navigate('/ordermanagement');
    dispatchNav(headerNavItem);
    dispatchHeaderNav(headerNavItem);
  }

  useEffect(() => {
    if (addressSearchText?.length >= 3) {
      setAddressListLoad(true)
      dispatch(getAddressDropDownList(addressSearchText));
    }
  }, [addressSearchText])

  useEffect(() => {
    const addDropdownList = addressDropDownList?.map((item: any, index: number) =>
      ({ text: item.description, label: item.description, value: item.place_id, key: item.place_id })
    );
    setAddressDropDownListTemp(addDropdownList)
    setAddressListLoad(false)
  }, [addressDropDownList])

  useEffect(() => {
    if (addressDetails?.hasOwnProperty("address1") || addressDetails?.hasOwnProperty("address2")) {
      setAddressSearchText('')
      dispatch(TransferAction.setAfeBranchAddressDetail({
        ...afeBranchAddressDetail,
        addLine1: addressDetails?.address1,
        addLine1Error: validateAddressLine1(addressDetails?.address1, 'AddressLine1'),
        addLine2: addressDetails?.address2,
        addLine2Error: validateAddressLine1(addressDetails?.address2, 'AddressLine2'),
        assetCity: addressDetails?.city,
        assetCityError: validateCity(addressDetails?.city),
        assetState: addressDetails?.state,
        assetStateError: validateState(addressDetails?.state),
        assetZip: addressDetails?.postalCode,
        assetZipError: validateZip(addressDetails?.postalCode)
      }));
    }
  }, [addressDetails])

  useEffect(() => {
    if ((isOrderCanceled.approval || cartOrderDelete) && isCancelRequestClicked) {
      setIsCancelRequestClicked(false);
      let decriptionTxt = (
        <p>Order Cancelled Successfully</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: rejectedBee,
        title: "CANCEL ORDER",
        isDialogVisible: true,
        isTitleWarning: false,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          dispatch(TransferAction.setIsChangesOccuredInCart(false))
          dispatchSetIsOrderCanceled(false)
          commonClearValues();
          setClickedAdd(false);
          dispatchNav(headerNav);
          navigate('/ordermanagement')
          dispatch(setDeleteCartOrder(false))
          dispatch(TransferAction.setAfeOrderByIdData({}))
        },
      });
    } else if ((!isOrderCanceled.approval || !cartOrderDelete) && isCancelRequestClicked) {
      setIsCancelRequestClicked(false);
      let decriptionTxt = (
        <div>
          <p>Order Cancelled Failed</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: rejectedBee,
        title: "CANCEL ORDER",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        popupOutlinebtnOnclick: () => {
          hideDialog();
          dispatch(setDeleteCartOrder(false))
        },
      });
    }
  }, [isOrderCanceled?.approval, cartOrderDelete])

  useEffect(() => {
    if (leadrOrderValidation != null) {
      if (leadrOrderValidation) {
        dispatch(TransferAction.setAfeAssetDetailData({
          ...afeAssetDetailData,
          existingOrderRequestIdError: ''
        }));
      } else {
        dispatch(TransferAction.setAfeAssetDetailData({
          ...afeAssetDetailData,
          existingOrderRequestIdError: 'Please enter valid Order Id'
        }));
      }
      dispatch(TransferAction.setLeadOrderValidation(null));
    }
  }, [leadrOrderValidation])

  const numberval = (response: any) => {
    if (response?.frsOrderNumber != null && response?.leadrOrderNumber != null) {
      return ("FRS # " + response?.frsOrderNumber + ", " + "LEADR # " + response?.leadrOrderNumber)
    } else if (response?.frsOrderNumber != null) {
      return ("FRS # " + response?.frsOrderNumber)
    } else if (response?.leadrOrderNumber != null) {
      return ("LEADR # " + response?.leadrOrderNumber)
    }
  }

  useEffect(() => {
    if (afeAssetValidation != null && (afeAssetValidation?.assetNumber != null && afeAssetValidation?.assetNumber != undefined)) {
      if (!afeAssetValidation?.isValid) {
        // Format the error message to include order number like other request types
        let errorMessage = afeAssetValidation?.validationMessage;
        const orderInfo = numberval(afeAssetValidation);
        if (orderInfo) {
          errorMessage = `${afeAssetValidation?.validationMessage} ${orderInfo}`;
        }
        
        dispatch(TransferAction.setAfeAssetDetailData({
          ...afeAssetDetailData,
          assetNumber: afeAssetValidation?.assetNumber,
          assetNumberError: errorMessage
        }));
      } else {
        dispatch(TransferAction.setAfeAssetDetailData({
          ...afeAssetDetailData,
          assetNumber: afeAssetValidation?.assetNumber,
          assetNumberError: '',
          unitNumber: afeAssetValidation?.asset?.unitNumber == '' || afeAssetValidation?.asset?.unitNumber == undefined ? null : afeAssetValidation?.asset?.unitNumber,
          eqStatus: afeAssetValidation?.asset?.eqStatus == '' || afeAssetValidation?.asset?.eqStatus == undefined ? null : afeAssetValidation?.asset?.eqStatus,
          eqClass: afeAssetValidation?.asset?.equipmentClass == '' || afeAssetValidation?.asset?.equipmentClass == undefined ? null : afeAssetValidation?.asset?.equipmentClass,
          year: afeAssetValidation?.asset?.modelYear == '' || afeAssetValidation?.asset?.modelYear == undefined ? null : afeAssetValidation?.asset?.modelYear,
          description: afeAssetValidation?.asset?.description == '' || afeAssetValidation?.asset?.description == undefined ? null : afeAssetValidation?.asset?.description,
          color: afeAssetValidation?.asset?.color, // no dta
          vinSerialNumber: afeAssetValidation?.asset?.serialNumber == '' || afeAssetValidation?.asset?.serialNumber == undefined ? null : afeAssetValidation?.asset?.serialNumber,
          licenseNumber: afeAssetValidation?.asset?.licensePlateNumber == '' || afeAssetValidation?.asset?.licensePlateNumber == undefined ? null : afeAssetValidation?.asset?.licensePlateNumber,
          netBookedValue: formatPrice(afeAssetValidation?.asset?.netBookedValue, 2),
          cost: formatPrice(afeAssetValidation?.asset?.acquisitionCost, 2),
        }));
      }
      dispatch(TransferAction.setAFEAssetValidation(null));
    }
  }, [afeAssetValidation])

  useEffect(() => {
    setHeaderNavItem(headerNav);
  }, [headerNav]);

  const orderSuccessResponsePopUp = () => {    
    const labelName = "AFE Request";
    let popUpDescriptionTxt;
    
    if (currentClickType === "Save") {
      popUpDescriptionTxt = (
        <>
          <p>{labelName} has been saved successfully.</p>
        </>
      );
    } else if (currentClickType === "Submit") {
      popUpDescriptionTxt = (
        <>
          <p>{labelName} has been created successfully.</p>
          <p>
            <b>{CONSTANTS.LEADR_ORDER_NUMBER} :</b> {saveAfeReclassification?.orderId}
          </p>
        </>
      );
    }

    setPopupcontent({
      ...Popupcontent,
      titleImg: SuccessBee,
      title: CONSTANTS.TITLE_SUCCESS,
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: popUpDescriptionTxt,
      primaryBtnText: "",
      outlineBtnText: "Close",
      popupOutlinebtnOnclick: () => { 
        hideDialog()
        dispatch(TransferAction.setIsEditOrder(false));
        dispatch(TransferAction.setAfeOrderByIdData({}))
        dispatch(RequisitionAction.setIsChangesOccured(false))
        clearValues()
      },
      isSingleConfirmationBtn: true,
    });
  }

  const orderErrorResponsePopUp = () => {
    let popUpDescriptionTxt = (
      <>
        <p>Error occured while creating the AFE Request.</p>
      </>
    );
    let popupTitle = CONSTANTS.TITLE_CONFIRMATION
    if(saveAfeReclassification?.errorMessage != ""){
      popUpDescriptionTxt = (
        <>
          <p>{saveAfeReclassification?.errorMessage}</p>
        </>
      );
      popupTitle = "WARNING"
    }
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: popupTitle,
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: popUpDescriptionTxt,
      primaryBtnText: "",
      outlineBtnText: "Close",
      popupOutlinebtnOnclick: () => { 
        hideDialog()
      },
      isSingleConfirmationBtn: true,
    });
  }

  useEffect(() => {
    if (currentClickType && saveAfeReclassification != null) {
      if (saveAfeReclassification?.orderId) {
        orderSuccessResponsePopUp();
      } else {
        orderErrorResponsePopUp();
      }
      dispatch(TransferAction.setSaveAfeReClassification(null));
      setCurrentClickType('');
    }
  }, [saveAfeReclassification, currentClickType])

  useEffect(() => {
    setAttachmentsList(docList);
    setList(docList)
    if (docList?.length > 0) {
      dispatch(TransferAction.setAfeReClassificationData({
        ...afeReClassificationData,
        uploadAttachmentsError: ''
      }))
      dispatch(TransferAction.setAfeAssetDetailData({
        ...afeAssetDetailData,
        uploadAttachmentsError: ''
      }))
    }
  }, [docList])

  const validateInvoicedAmount = (value: any) => {
    let valTemp = value?.replace(/,/g, "")
    if (valTemp?.length == 0 || valTemp?.toString().trim()?.length == 0 || valTemp == null || valTemp == undefined || valTemp == '0.00') {
      return 'Please enter Quoted Amount';
    } else if (valTemp?.length > 9) {
      return 'Quoted Amount should be less than 8 digits';
    } else if (selectedAfeType?.label == CONSTANTS.FLEET_EQUIPMENT && parseFloat(valTemp) < 1500) {
      return 'Quoted Amount should be greater than or equal to $1500';
    } else {
      return '';
    }
  }

  const validateAddressLine1 = (value: any, fieldType?: any) => {
    if (value?.length > 255) {
      return `Address Line ${fieldType == 'AddressLine1' ? 1 : 2} should be less than 255 characters`;
    } else if ((value?.length == 0 || value?.toString().trim()?.length == 0 || value == null || value == undefined) && fieldType == 'AddressLine1') {
      return `Please enter Address Line ${fieldType == 'AddressLine1' ? 1 : 2}`;
    } else {
      return '';
    }
  }

  const validateCity = (value: any) => {
    if (value?.length > 50) {
      return 'City should be less than 50 characters';
    } else if (value?.length == 0 || value?.toString().trim()?.length == 0 || value == null || value == undefined) {
      return 'Please enter City';
    } else {
      return '';
    }
  }

  const validateState = (value: any) => {
    if (value?.length > 2) {
      return 'State should be 2 characters';
    } else if (value?.length == 0 || value?.toString().trim()?.length == 0 || value == null || value == undefined) {
      return 'Please enter State';
    } else {
      return '';
    }
  }

  const validateZip = (value: any) => {
    if (value?.length > 10) {
      return 'Please enter zip code less than 10 digits.';
    } else if (value?.length == 0 || value?.toString().trim()?.length == 0 || value == null || value == undefined) {
      return 'Please enter zip code';
    } else {
      return '';
    }
  }

  const validateJeDescription = (value: any) => {
    if (value?.length > 255) {
      return 'JE Description should be less than 255 characters';
    } else if (value?.length == 0 || value?.toString().trim()?.length == 0 || value == null || value == undefined) {
      return 'Please enter JE Description';
    } else {
      return '';
    }
  }

  const validateLeaseID = (valTemp: any) => {
    if (valTemp?.length == 0 || valTemp?.toString().trim()?.length == 0 || valTemp == null || valTemp == undefined) {
      return 'Please enter Lease ID #';
    } else if (valTemp?.length > 30) {
      return 'Lease ID # should be less than 30 characters';
    } else {
      return '';
    }
  }

  const validateLeaseExpirationDate = (valTemp: any) => {
    if (valTemp == null || valTemp == undefined) {
      return 'Please enter Lease Expiration Date';
    } else {
      return '';
    }
  }

  const validateAssetNumber = (valTemp?: any) => {
    const existingError = afeAssetDetailData?.assetNumberError;
    if (existingError && existingError !== `Click 'Get Asset Info' button to validate`) {
      return existingError;
    }
    
    if (valTemp?.length == 0 || valTemp?.toString().trim()?.length == 0 || valTemp == null || valTemp == undefined) {
      return 'Please enter Asset Number';
    } else if (valTemp?.length > 9) {
      return 'Asset Number should be less than 9 digits';
    } else {
      return '';
    }
  }

  const validateRepairRequest = (valTemp?: any) => {
    if (afeAssetDetailData?.isRepairRequest == null || afeAssetDetailData?.isRepairRequest == undefined) {
      return 'Please select the Repair Request';
    } else {
      return '';
    }
  }

  const onInvoicedAmountchange = (e: any) => {
    const onChangVal = e.target.value
    const regEx = /^[\d\.?\d,\b]*$/;
    const valArr = onChangVal.split('.')
    const checkNumber = regEx.test(onChangVal);
    if (!checkNumber || valArr.length > 2) {
      return;
    }
    else {
      dispatch(RequisitionAction.setIsChangesOccured(true));
      dispatch(TransferAction.setAfeAssetDetailData({
        ...afeAssetDetailData,
        invoicedAmount: e.target.value,
        invoicedAmountError: validateInvoicedAmount(e.target.value)
      }));
    }

  }

  const onInvoicedAmountBlur = (e?: any) => {
    e?.preventDefault();
    dispatch(TransferAction.setAfeAssetDetailData({
      ...afeAssetDetailData,
      invoicedAmount: formatPrice(e.target.value, 2),
      invoicedAmountError: validateInvoicedAmount(e.target.value)
    }));

  }

  const onLeaseIdchange = (e: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(TransferAction.setAfeAssetDetailData({
      ...afeAssetDetailData,
      leaseId: e.target.value,
      leaseIdError: validateLeaseID(e.target.value)
    }));
  }

  const handleLeaseExpirationDateChange = (date: any) => {
    if (date != null) {
      dispatch(RequisitionAction.setIsChangesOccured(true));
      dispatch(TransferAction.setAfeAssetDetailData({
        ...afeAssetDetailData,
        leaseExpirationDate: date,
        leaseExpirationDateError: validateLeaseExpirationDate(date)
      }));
    }
  }

  const filterLocationOptionAddress1 = (value: any, action: any) => {
    if (action.action === "input-change") {
      dispatch(RequisitionAction.setIsChangesOccured(true));
      setAddressSearchText(value);
      dispatch(TransferAction.setAfeBranchAddressDetail({
        ...afeBranchAddressDetail,
        addLine1: value,
        addLine1Error: validateAddressLine1(value, 'AddressLine1')
      }));
    }
  };

  const onAddress1change = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(getAddressDetails(e?.key))
  }

  const onAddress2change = (e: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(TransferAction.setAfeBranchAddressDetail({
      ...afeBranchAddressDetail,
      addLine2: e.target.value,
      addLine2Error: validateAddressLine1(e?.target?.value, 'AddressLine2')
    }));
  }

  const onCitychange = (e: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(TransferAction.setAfeBranchAddressDetail({
      ...afeBranchAddressDetail,
      assetCity: e.target.value,
      assetCityError: validateCity(e?.target?.value)
    }));
  }

  const onStateChange = (e: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(TransferAction.setAfeBranchAddressDetail({
      ...afeBranchAddressDetail,
      assetState: e.target.value,
      assetStateError: validateState(e?.target?.value)
    }));
  }

  const onZipChange = (e: any) => {
    e?.preventDefault();
    const onChangVal = e.target.value
    const regEx = /^[\d\.?\d,\b]*$/;
    const valArr = onChangVal.split('.')
    const checkNumber = regEx.test(onChangVal);
    if (!checkNumber || valArr.length > 2) {
      return;
    }
    else {
      dispatch(RequisitionAction.setIsChangesOccured(true));
      dispatch(TransferAction.setAfeBranchAddressDetail({
        ...afeBranchAddressDetail,
        assetZip: e.target.value,
        assetZipError: validateZip(e?.target?.value)
      }));
    }
  }

  const onJeDescriptionChange = (e: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(TransferAction.setAfeAssetDetailData({
      ...afeAssetDetailData,
      jeDescription: e.target.value,
      jeDescriptionError: validateJeDescription(e?.target?.value)
    }));
  }

  const onRepairRequiredChange = (e: any, item?: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    const updateData: any = {
      ...afeAssetDetailData,
      isRepairRequest: item
    };
    
    if (item?.key === 'No') {
      updateData.isRepairValueOver1500 = { key: '', text: '' };
      updateData.isEfficiencyIncreased = { key: '', text: '' };
      updateData.isLifeExtendedOneYear = { key: '', text: '' };
    }
    
    dispatch(TransferAction.setAfeAssetDetailData(updateData));
  }

  const onEfficiencyIncreasedChange = (e: any, item?: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(TransferAction.setAfeAssetDetailData({
      ...afeAssetDetailData,
      isEfficiencyIncreased: item
    }));
  }

  const onLifeExtendedOneYearChange = (e: any, item?: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(TransferAction.setAfeAssetDetailData({
      ...afeAssetDetailData,
      isLifeExtendedOneYear: item
    }));
  }

  const onRepairOver1500Change = (e: any, item?: any) => {
    e?.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(true));
    dispatch(TransferAction.setAfeAssetDetailData({
      ...afeAssetDetailData,
      isRepairValueOver1500: item
    }));
  }

  const onAssetNumberChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true));
    let errorVal = validateAssetNumber(e.target.value);
    dispatch(TransferAction.setAfeAssetDetailData({
      ...afeAssetDetailData,
      assetNumber: e.target.value,
      assetNumberError: errorVal?.length ? errorVal : `Click 'Get Asset Info' button to validate`
    }));
  }

  const handleKeyPress = (event: any) => {
    if (event.charCode === 13) {
      onGetAssetInfoClick(event);
    }
  }

  const onGetAssetInfoClick = (e: any) => {
    e.preventDefault();
    dispatch(TransferAction.getAFEAssetValidation({
      assetNumber: afeAssetDetailData?.assetNumber,
      costCenterNo: afeReClassificationData?.costCenterNo?.trim(),
      reasonReplacementId: 0,
      requestType: "AFERequest"
    }));
  }

  const isUploaded = (name: string) =>
    attachmentsList.find((x: any) => getFileName(x.attachmentUrl) === name);

  // To upload attachments
  const onUploadClick = (fileList: Array<File>) => {
    setError("");
    const filteredList = [
      ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
    ];
    if (filteredList.length > 0 && filteredList.length <= 5) {
      setError("");
      let totalSize = 0;
      filteredList.forEach((file: File) => {
        totalSize = totalSize + (file.size || 0);
      });
      if (totalSize <= 5000000) {
        setError("");
        const formData = new FormData();
        formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

        for (let i = 0; i < filteredList.length; i++) {
          formData.append("Files", filteredList[i] as any);
        }
        dispatchUploadAttachments({ formData, filteredList, list: attachmentsList });
      } else {
        setError("Please Upload files without exceeding maximum size of 5MB");
      }
    } else if (fileList.length > 5) {
      setError(
        "Please Upload files without exceeding maximum limit of 5 files"
      );
    } else {
      if (fileList.length > 0 && !filteredList.length) {
        setError("All files are uploaded try to add new files");
      } else {
        setError("Choose at least 1 file to upload");
      }
    }
  };

  const onRemoveClick = (index: number) => {
    const newArr = attachmentsList.slice();
    newArr.splice(index, 1);
    const assetTemp = afeReClassificationData ? JSON.parse(JSON.stringify(afeReClassificationData)) : {};
    const assets = assetTemp?.attachments?.filter((attach: any) => !!newArr?.find((doc: any) => doc.fileName === attach.fileName))

    const newFileList = JSON.parse(JSON.stringify(list));
    newFileList.splice(index, 1);
    setList(newFileList);
    dispatch(TransferAction.setAssetData(assets));
    dispatch(TransferAction.setAfeReClassificationData(assets));
    dispatchRemoveAttachment(newArr);
    setError("");
  };

  const getrequiredFields = (afeType?: any) => {
    if (afeType.label == CONSTANTS.BUILDING_IMPROVEMENTS) {
      return buildingImprovementsRequiredFields;
    } else if (afeType?.label == CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP) {
      return furnitureFixturesRequiredFields;
    } else if (afeType?.label == CONSTANTS.LEASEHOLD_IMPROVEMENTS) {
      return LeaseImprovementsRequiredFields;
    } else if (afeType?.label == CONSTANTS.FLEET_EQUIPMENT) {
      return fleetEquipmentRequiredFields;
    }
  }

  const validateOnSubmit = () => {
    let isValid = true;
    let isValidOnSplitAndquestion = true;
    let requiredFields = getrequiredFields(selectedAfeType);

    let errors: any = {};
    const validateField = (field: string, value: any, validationFn: Function, errorKey: string, dataType: 'asset' | 'branch') => {
      const validationResult = validationFn(value);
      if (validationResult) {
        isValid = false;
        if (dataType === 'asset') {
          errors[field + 'Error'] = validationResult;
        } else if (dataType === 'branch') {
          errors[field + 'Error'] = validationResult;
        }
      }
    };
    let afeAssetDetailDataTemp = afeAssetDetailData ? JSON.parse(JSON.stringify(afeAssetDetailData)) : {};
    let afeBranchAddressDetailTemp = afeBranchAddressDetail ? JSON.parse(JSON.stringify(afeBranchAddressDetail)) : {};
    requiredFields?.forEach((field: any) => {

      if (field == 'invoicedAmount') {
        validateField('invoicedAmount', afeAssetDetailDataTemp?.invoicedAmount, validateInvoicedAmount, 'invoicedAmountError', 'asset');
      }
      if (field == 'jeDescription') {
        validateField('jeDescription', afeAssetDetailDataTemp?.jeDescription, validateJeDescription, 'jeDescriptionError', 'asset');
      }
      if (field == 'addLine1') {
        validateField('addLine1', afeBranchAddressDetailTemp?.addLine1, (value: any) => validateAddressLine1(value, 'AddressLine1'), 'addLine1Error', 'branch');
      }
      if (field == 'addLine2') {
        validateField('addLine2', afeBranchAddressDetailTemp?.addLine2, (value: any) => validateAddressLine1(value, 'AddressLine2'), 'addLine2Error', 'branch');
      }
      if (field == 'assetCity') {
        validateField('assetCity', afeBranchAddressDetailTemp?.assetCity, validateCity, 'assetCityError', 'branch');
      }
      if (field == 'assetState') {
        validateField('assetState', afeBranchAddressDetailTemp?.assetState, validateState, 'assetStateError', 'branch');
      }
      if (field == 'assetZip') {
        validateField('assetZip', afeBranchAddressDetailTemp?.assetZip, validateZip, 'assetZipError', 'branch');
      }
      if (field == 'assetNumber') {
        validateField('assetNumber', afeAssetDetailDataTemp?.assetNumber, validateAssetNumber, 'assetNumberError', 'asset');
      }
      if (field == 'leaseId') {
        validateField('leaseId', afeAssetDetailDataTemp?.leaseId, validateLeaseID, 'leaseIdError', 'asset');
      }
      if (field == 'leaseExpirationDate') {
        validateField('leaseExpirationDate', afeAssetDetailDataTemp?.leaseExpirationDate, validateLeaseExpirationDate, 'leaseExpirationDateError', 'asset');
      }
      if (field == 'repairRequest') {
        validateField('repairRequest', afeAssetDetailDataTemp?.isRepairRequest, validateRepairRequest, 'repairRequestError', 'asset');
      }
    });
    if (docList?.length == 0) {
      isValid = false;
      errors['uploadAttachmentsError'] = 'Please upload at least one document';
    }
    // Dispatch all errors at once if any exist
    if (!isValid) {
      if (Object?.keys(errors)?.length > 0) {
        dispatch(TransferAction.setAfeAssetDetailData({ ...afeAssetDetailDataTemp, ...errors }));
        dispatch(TransferAction.setAfeBranchAddressDetail({ ...afeBranchAddressDetailTemp, ...errors }));
      }
    }
    return { isValid, isValidOnSplitAndquestion };
  };

  const onClickOfSaveOrSubmit = (e: any, clickType?: any) => {
    e.preventDefault();
    setCurrentClickType(clickType || ''); 
    let isValidForSave = validateOnSubmit()
    if (isValidForSave?.isValid && isValidForSave?.isValidOnSplitAndquestion) {
      ReactToAPI({
        afeAssetDetailData,
        afeReClassificationData,
        afeBranchAddressDetail,
        afeBranchSplitData,
        dispatch,
        docList,
        clickType,

      })
    } else {
      let val: any = "";
      if (!isValidForSave?.isValid) {
        val = 'Please fill appropriate values in all the required fields';
      }

      const descriptionTxt = (<>
        {val && <p>{val}</p>}
      </>);
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: 'INFORMATION',
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: descriptionTxt,
        outlineBtnText: "OK",
        popupOutlinebtnOnclick: () => {
          hideDialog();
        },
        isSingleConfirmationBtn: true,
      });
    }
  }

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  }



  const onClickCancel = (e?: any) => {
    e.preventDefault();
    let decriptionTxt = (
      <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "UNSAVED CHANGES",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      popupOutlinebtnOnclick: () => {
        hideDialog();
      },
      popupPrimarybtnOnclick: () => {
        hideDialog();
        clearValues()
      },
      isSingleConfirmationBtn: false,
    });
  }

  const commonClearValues = () => {
    dispatchUploadAttachments({});
    dispatch(TransferAction.setAfeAssetDetailData({}));
    dispatch(TransferAction.setAfeBranchAddressDetail({}));
  }
  const onClickDeleteicon = () => {
    commonClearValues()
    setClickedAdd(false)
  }

  const onClickOfReset = (e?: any) => {
    e?.preventDefault();
    commonClearValues()
  }

  const onClickOfRevertChanges = (e?: any) => {
    e?.preventDefault();
    if (afeOrderByIdData?.orderId == id) {
      ApiToReact({
        dispatch,
        afeOrderByIdData,
        UploadAttachmentsDispatch,
        Moment
      })
    }
  }

  const popupCancelPrimarybtnOnclick = (
    item: any,
    comment: string,
    actionby: string,
    value: any
  ) => {
    if (afeOrderByIdData?.orderStatus == "Saved") {
      const deleteDraftOrder = {
        orderId: afeOrderByIdData?.orderId,
        comments: comment,
        savedBy: getUserDetails?.emailId
      };
      dispatchGetDeleteCartOrderById(deleteDraftOrder)
    } else {
      cancelOrderRequest({ orderId: afeOrderByIdData?.orderId, savedBy: getUserDetails?.emailId, comments: comment });
    }
    hideCancelDialog();
  };

  const hideCancelDialog = () => {
    setCancelPopContent({ ...cancelPopContent, isDialogVisible: false })
  }

  const cancelRequestOnClick = (e?: any) => {
    e?.preventDefault();
    setIsCancelRequestClicked(true)
    const cancelOrdersubtext = (
      <div>
        <p>Are you sure you want to cancel the Order</p>
        <p>
          <b>LEADR Order # : </b>{id}
        </p>
      </div>
    );
    setCancelPopContent({
      ...cancelPopContent,
      titleImg: rejectedBee,
      title: "CANCEL ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      popupOutlinebtnOnclick: () => {
        hideCancelDialog();
        setIsCancelRequestClicked(false);
      }
    });
  }

  return (
    <Afereclassification
      selectedAfeType={selectedAfeType}
      onInvoicedAmountchange={onInvoicedAmountchange}
      afeReClassificationData={afeReClassificationData}
      onAddress1change={onAddress1change}
      onInvoicedAmountBlur={onInvoicedAmountBlur}
      onAddress2change={onAddress2change}
      onCitychange={onCitychange}
      onStateChange={onStateChange}
      onZipChange={onZipChange}
      onJeDescriptionChange={onJeDescriptionChange}
      onRepairRequiredChange={onRepairRequiredChange}
      onEfficiencyIncreasedChange={onEfficiencyIncreasedChange}
      onLifeExtendedOneYearChange={onLifeExtendedOneYearChange}
      onRepairOver1500Change={onRepairOver1500Change}
      afeAssetDetailData={afeAssetDetailData}
      afeBranchAddressDetail={afeBranchAddressDetail}
      onUploadClick={onUploadClick}
      onRemoveClick={onRemoveClick}
      error={error}
      setError={setError}
      list={list}
      setList={setList}
      docList={docList}
      onLeaseIdchange={onLeaseIdchange}
      handleLeaseExpirationDateChange={handleLeaseExpirationDateChange}
      onClickOfSaveOrSubmit={onClickOfSaveOrSubmit}
      onAssetNumberChange={onAssetNumberChange}
      onClickCancel={onClickCancel}
      Popupcontent={Popupcontent}
      onGetAssetInfoClick={onGetAssetInfoClick}
      handleKeyPress={handleKeyPress}
      onClickDeleteicon={onClickDeleteicon}
      afeOrderByIdData={afeOrderByIdData}
      isEditOrder={isEditOrder}
      onClickOfReset={onClickOfReset}
      onClickOfRevertChanges={onClickOfRevertChanges}
      cancelRequestOnClick={cancelRequestOnClick}
      cancelPopContent={cancelPopContent}
      hideCancelDialog={hideCancelDialog}
      popupCancelPrimarybtnOnclick={popupCancelPrimarybtnOnclick}
      addressListLoad={addressListLoad}
      addressSearchText={addressSearchText}
      addressDropDownListTemp={addressDropDownListTemp}
      filterLocationOptionAddress1={filterLocationOptionAddress1}
    />
  );
}

export default AfereclassificationContainer;
